
import React from "react";
function Home() {

  
//
//  function completeAction(id) {
//    // here create the action line with id
//    console.log("CardListObj, button clicked, id = ", id);
//  }

return (
       <div class="div_3_col">
       	<h1>Home (test) </h1>
       	
       	<div><a href="/observership/Login">Login</a></div>       	
       	<div><a href="/observership/CreateAccount">Create Account</a></div>
       	<div><a href="/observership/RequestActivateToken">Request activation token</a></div>
       	<div><a href="/observership/ForgotPassword">Forgot Password </a></div>
       	<br/><br/>
       	<div><a href="/observership/">Dashboard</a></div>
       	<div><a href="/observership/UploadVisa">Upload Visa</a></div>
       	<div><a href="/observership/ObservershipApplicationForm">Apply</a></div>
       	<div><a href="/observership/DataRequestForm">Data Request Form</a></div>
       	
       	
		

       </div>
)

};
export default Home;